import importerStore from '@shared/importer/importer-store';
import { CoachService } from '@modules/coach/coach-service';
import coachImporterFields from '@modules/coach/coach-importer-fields';
import { i18n } from '@shared/i18n';

export default importerStore(
  CoachService.import,
  coachImporterFields,
  i18n('entities.coach.importer.fileName'),
  i18n('entities.coach.importer.hint'),
);
